import React from 'react';
import '../../styles/LessonCoverScreen.css';

export default function LessonCoverScreen({ 
  title, 
  text, 
  image,
}) {
  return (
    <div 
      className="lesson-cover-screen" 
    >
      <div className="lesson-cover">
        
        {title && <div
          className={`
            lesson-cover-title 
            font-${title?.fontSize ?? "font-md"}
            text-${title?.textAlign ?? "text-left"}
          `}
          dangerouslySetInnerHTML={{__html: title.value}}>
        </div>}

        {text && <div
          className={`
          lesson-cover-text font-${text?.fontSize ?? "md"}
          text-${text?.textAlign ?? "text-left"}`}
          dangerouslySetInnerHTML={{__html: text.value}}>
        </div>}

      </div>

      {image && (
        <img className="lesson-cover-img" src={image} alt="" />
      )}
    </div>
  );
}